import { defineSlotRecipe } from "@chakra-ui/react";
import { cardAnatomy } from '@chakra-ui/react/anatomy'

export const cardRecipe = defineSlotRecipe({
  className: "chakra-card",
  slots: cardAnatomy.keys(),
  base: {
    root: {
      borderRadius: '2xl',
      '--card-padding': '2.25rem',
      boxShadow: '0px 0px 1px 0px rgba(24,24,27,0.2), 0px 1px 2px 0px rgba(24,24,27,0.1)',
    },
    header: {
      gap: '3',
      paddingInline: '2.25rem',
      paddingTop: '2.25rem',
    },
    body: {
      paddingInline: '2.25rem',
      paddingBlock: '2.25rem',
    },
    footer: {
      paddingInline: '2.25rem',
      paddingBottom: '2.25rem',
    },
  },
  variants: {
    variant: {
      outline: {
        root: {
          borderWidth: '0px',
          borderColor: 'transparent',
        },
      },
    },
  },
})